import {Space, Spin} from "antd";
import '../../style/css/general.css'
import {useEffect, useState} from "react";

const LoadPage = (props) => {
    const [display, setDisplay] = useState(props.display)
    let timer = null

    useEffect(() => {
        if (!props.display) {
            timer = setTimeout(() => {
                setDisplay(false)
            }, 500);
        } else {
            setDisplay(true)
        }
        return () => clearTimeout(timer)
    }, [props.display])

    if (display) {
        return (
            <>
                <Space className={props.display ? 'loading show' : 'loading hidden'}>
                    <Spin />
                </Space>
            </>
        )
    } else {
        return null
    }


}

export default LoadPage